import * as React from "react";
const SvgFiRrGem = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-gem_svg__a)">
      <path d="M23.147 9.471 22.36 8.4A5.88 5.88 0 0 0 17.632 6H6.383a5.9 5.9 0 0 0-4.662 2.309l-.82 1.074a4.42 4.42 0 0 0 .547 5.937l7.99 7.707a3.82 3.82 0 0 0 2.55.969 3.9 3.9 0 0 0 2.6-1l7.936-7.633a4.39 4.39 0 0 0 .623-5.892m-2.4.107.787 1.074q.12.165.208.348h-4.79a6.6 6.6 0 0 0-.373-1.4L15.94 8h1.693a3.88 3.88 0 0 1 3.115 1.578m-8.757 10.51-2.769-6.27A4.6 4.6 0 0 1 8.995 13h5.952q-.062.33-.176.647zM9.1 11q.063-.27.157-.529L10.241 8h3.544l.937 2.343q.124.322.2.657zM3.311 9.521A3.88 3.88 0 0 1 6.383 8h1.7L7.4 9.729A6.6 6.6 0 0 0 7.033 11H2.245q.103-.212.247-.4zm-.5 4.333a2.4 2.4 0 0 1-.6-.854h4.772c.066.539.196 1.068.387 1.576l2.827 6.4zm10.96 7.16 2.854-6.614a6.6 6.6 0 0 0 .344-1.4H21.8a2.5 2.5 0 0 1-.633.9zM12 4a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1M16.553 3.9a1 1 0 0 0 1.347-.453l1-2a1 1 0 0 0-1.79-.894l-1 2a1 1 0 0 0 .443 1.347M6.105 3.447A1.003 1.003 0 0 0 7.9 2.553l-1-2a1 1 0 0 0-1.79.894z" />
    </g>
    <defs>
      <clipPath id="fi-rr-gem_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGem;
